/* BHBY PDP v2 buy box + landing interactions. Vanilla, no deps.
   Liquid emits all prices/IDs as data-attributes; this file only wires state.
   Money values are in CENTS (Shopify convention) and formatted client-side. */
(function () {
  'use strict';

  function money(cents) {
    if (cents === null || isNaN(cents)) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  // CRO event publishing. Guarded so an analytics failure (missing
  // Shopify.analytics, ad blocker, etc.) can never break add to cart or any
  // other buy box interaction. See shopify/data/cro/THEME_WIRING.md section 3.
  function bhbyAb() {
    return (document.documentElement.dataset && document.documentElement.dataset.ab) || null;
  }
  function bhbyPublish(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}
  }

  // Human cadence from a ReCharge selling-plan name ("Delivery every 30 days" →
  // "every 30 days"). Returns '' if the name carries no interval, so the clarity
  // copy degrades gracefully to a generic "recurring schedule".
  function cadenceFromPlan(name) {
    if (!name) return '';
    var m = name.match(/every\s+(\d+)\s*(day|week|month)/i) || name.match(/(\d+)\s*(day|week|month)/i);
    if (!m) return '';
    var n = m[1], unit = m[2].toLowerCase();
    return 'every ' + n + ' ' + unit + (n === '1' ? '' : 's');
  }

  // Sticky-bar meta line ("3 Bottles · Sub & Save"). Desktop shows pack + mode;
  // mobile is terser (mode when subscribing, else pack) to keep the CTA on one line.
  // Viewport-dependent text is recomputed here so a resize re-picks the right string.
  function applyStickyMeta(el) {
    var desktop = window.matchMedia('(min-width:900px)').matches;
    el.textContent = (desktop ? el.getAttribute('data-meta-desktop') : el.getAttribute('data-meta-mobile')) || '';
    var isSub = el.getAttribute('data-is-sub') === '1';
    el.style.color = isSub ? '#1A7F5A' : '#6B6B6B';
    el.style.fontWeight = isSub ? '700' : '600';
  }

  /* ------------------------------------------------------------------ */
  /* Buy box                                                             */
  /* ------------------------------------------------------------------ */
  function initBuybox(box) {
    var tiers = Array.prototype.slice.call(box.querySelectorAll('[data-tier]'));
    var modes = Array.prototype.slice.call(box.querySelectorAll('[data-mode]'));
    var atcBtns = Array.prototype.slice.call(document.querySelectorAll('[data-bhby-atc]'));
    var form = box.querySelector('form[data-product-form]') || document.getElementById('bhby-product-form');
    var errorEl = box.querySelector('[data-quantity-error]');

    function selectedTier() { return box.querySelector('[data-tier].bhby-selected'); }
    function selectedMode() {
      var m = box.querySelector('[data-mode].bhby-selected');
      return m ? m.getAttribute('data-mode') : 'onetime';
    }

    // Write id + selling_plan into THE form that will be serialized, looked up
    // fresh inside that form on every call. document-wide queries broke here
    // once: a stale/cloned id input kept the default 1-pack variant while the
    // plan input updated, so 3/6-pack subscription adds posted a mismatched
    // pair and Shopify 422'd.
    function syncFormInputs() {
      if (!form) return;
      var tier = selectedTier();
      if (!tier) return;
      var isSub = selectedMode() === 'sub';
      var planId = tier.getAttribute('data-selling-plan') || '';
      var idInput = form.querySelector('[name="id"]');
      var planInput = form.querySelector('[name="selling_plan"]');
      if (idInput) idInput.value = tier.getAttribute('data-variant-id');
      if (planInput) {
        if (isSub && planId) { planInput.value = planId; planInput.disabled = false; }
        else { planInput.value = ''; planInput.disabled = true; }
      }
    }

    function sync() {
      var tier = selectedTier();
      if (!tier) return;
      var isSub = selectedMode() === 'sub';
      var planId = tier.getAttribute('data-selling-plan') || '';
      var hasPlan = planId.length > 0;
      if (isSub && !hasPlan) { isSub = false; setMode('onetime'); }

      var ot = parseInt(tier.getAttribute('data-ot-price'), 10);
      var sub = parseInt(tier.getAttribute('data-sub-price'), 10);
      var price = isSub && !isNaN(sub) ? sub : ot;
      var compare = isSub && !isNaN(sub) ? ot : parseInt(tier.getAttribute('data-compare-price') || '', 10);
      var perdayCents = parseInt(tier.getAttribute(isSub ? 'data-sub-perday' : 'data-ot-perday'), 10);

      box.querySelectorAll('[data-price-out]').forEach(function (el) { el.textContent = money(price); });
      document.querySelectorAll('[data-sticky-price-out]').forEach(function (el) { el.textContent = money(price); });

      // Sticky-bar selected pack + purchase mode.
      var packEl = tier.querySelector('.bhby-t-name');
      var pack = packEl ? packEl.textContent.trim().replace(/\b\w/g, function (c) { return c.toUpperCase(); }) : '';
      document.querySelectorAll('[data-sticky-meta-out]').forEach(function (el) {
        el.setAttribute('data-meta-desktop', pack + (pack ? ' · ' : '') + (isSub ? 'Sub & Save' : 'One-time'));
        // Mobile keeps BOTH the pack and the mode (was dropping the pack when
        // subscribing): "3 Bottles · Sub & Save". Pack alone when one-time.
        el.setAttribute('data-meta-mobile', pack + (isSub ? (pack ? ' · ' : '') + 'Sub & Save' : ''));
        el.setAttribute('data-is-sub', isSub ? '1' : '0');
        applyStickyMeta(el);
      });
      box.querySelectorAll('[data-pack-out]').forEach(function (el) { el.textContent = pack; });
      box.querySelectorAll('[data-compare-out]').forEach(function (el) {
        if (!isNaN(compare) && compare > price) { el.textContent = money(compare); el.style.display = ''; }
        else { el.style.display = 'none'; }
      });
      box.querySelectorAll('[data-perday-out]').forEach(function (el) { if (!isNaN(perdayCents)) el.textContent = money(perdayCents) + '/day'; });
      var chip = box.querySelector('[data-savings-out]');
      if (chip) chip.classList.toggle('bhby-show', isSub);

      // Shipping disclosure (CRO audit 2026-09-06, rank 3). Rate rule confirmed live
      // 2026-09-08 by probing /cart/shipping_rates.json: Free Shipping is offered when
      // the cart clears EITHER data-ship-free-weight grams OR data-ship-free-price cents,
      // Standard $7.99 only while weight stays at or under the weight bar. Test both, or
      // a 0 g pack over the dollar bar (BYOB) reads as paid when it actually ships free.
      var shipLine = box.querySelector('[data-ship-line]');
      if (shipLine) {
        // Free Shipping is offered when EITHER condition is met, so test both.
        var freeAt = parseInt(shipLine.getAttribute('data-ship-free-weight'), 10);
        var freeAtCents = parseInt(shipLine.getAttribute('data-ship-free-price'), 10);
        var grams = parseInt(tier.getAttribute('data-weight'), 10);
        var shipsFree = (!isNaN(grams) && !isNaN(freeAt) && grams >= freeAt) ||
                        (!isNaN(price) && !isNaN(freeAtCents) && price >= freeAtCents);
        var shipOut = shipLine.querySelector('[data-ship-out]');
        if (shipOut) {
          shipOut.textContent = shipsFree
            ? 'Ships free'
            : '+' + shipLine.getAttribute('data-ship-rate') + ' shipping, free on orders $' + shipLine.getAttribute('data-ship-threshold') + '+';
        }
        shipLine.classList.toggle('bhby-ship-paid', !shipsFree);
      }

      // Subscription terms next to the ATC (FTC ROSCA): frequency + renewal
      // price + cancel rights, visible whenever a subscription would be added.
      var terms = box.querySelector('[data-sub-terms]');
      if (terms) {
        if (isSub && hasPlan) {
          var planName = tier.getAttribute('data-plan-name') || 'Repeat delivery';
          terms.textContent = planName + ' · renews at ' + money(price) + ' · skip, pause, or cancel anytime';
          terms.hidden = false;
        } else {
          terms.hidden = true;
        }
      }

      // Update EVERY pack tier's price + per-day to match the mode, so toggling
      // Subscribe & Save visibly drops each pack's price (the whole reason to
      // subscribe). Previously the tier rows showed a hardcoded one-time price
      // that never moved, so customers saw no savings and stayed on 1-pack OT.
      // Tiers without a sub plan stay at one-time pricing.
      tiers.forEach(function (t) {
        var tOt = parseInt(t.getAttribute('data-ot-price'), 10);
        var tSub = parseInt(t.getAttribute('data-sub-price'), 10);
        var tUseSub = isSub && !isNaN(tSub);
        var pEl = t.querySelector('[data-tier-price]');
        var wEl = t.querySelector('[data-tier-was]');
        var pdEl = t.querySelector('[data-tier-perday]');
        if (pEl) pEl.textContent = money(tUseSub ? tSub : tOt);
        if (wEl) {
          if (tUseSub) { wEl.textContent = money(tOt); wEl.hidden = false; }
          else { wEl.hidden = true; }
        }
        if (pdEl) {
          var tpd = parseInt(t.getAttribute(tUseSub ? 'data-sub-perday' : 'data-ot-perday'), 10);
          if (!isNaN(tpd)) pdEl.textContent = money(tpd) + '/day';
        }
      });

      // sub mode availability + dynamic % label per tier (plans are 10/15/20 by pack)
      var subMode = box.querySelector('[data-mode="sub"]');
      if (subMode) {
        if (hasPlan) subMode.removeAttribute('data-unavailable');
        else subMode.setAttribute('data-unavailable', '');
        // Advertise the program's max subscribe discount ("up to 20%") on the
        // toggle, not the selected tier's %, so the best deal shows before the
        // shopper clicks up to a larger pack. Actual applied % stays accurate in
        // the price line / per-tier "subscribers save X%" copy.
        var pctOut = subMode.querySelector('[data-sub-pct-out]');
        if (pctOut) {
          var maxPct = parseInt(pctOut.getAttribute('data-sub-pct-max'), 10);
          pctOut.textContent = hasPlan && maxPct > 0 ? 'up to ' + maxPct + '%' : '';
        }
      }

      // Sync the theme-native product form's hidden inputs. theme.min.js owns
      // the actual submit (AJAX add + quick-cart drawer open).
      syncFormInputs();

      var available = tier.getAttribute('data-available') === 'true';
      atcBtns.forEach(function (b) {
        b.disabled = !available;
        var label = b.querySelector('[data-add-to-cart-text]') || b;
        label.textContent = available ? (b.getAttribute('data-label') || 'Add to cart') : 'Sold out';
      });
    }

    function setMode(name) {
      modes.forEach(function (m) {
        var on = m.getAttribute('data-mode') === name;
        m.classList.toggle('bhby-selected', on);
        m.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) { x.classList.remove('bhby-selected'); x.setAttribute('aria-checked', 'false'); });
        t.classList.add('bhby-selected'); t.setAttribute('aria-checked', 'true');
        sync();
        bhbyPublish('bhby_pack_selected', { bottles: t.getAttribute('data-bottles') || null, mode: selectedMode(), ab: bhbyAb() });
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); }
      });
    });
    modes.forEach(function (m) {
      m.addEventListener('click', function () {
        if (m.hasAttribute('data-unavailable')) return;
        setMode(m.getAttribute('data-mode'));
        sync();
        var st = selectedTier();
        bhbyPublish('bhby_sub_toggled', { mode: m.getAttribute('data-mode'), bottles: st ? (st.getAttribute('data-bottles') || null) : null, ab: bhbyAb() });
      });
    });

    // Add-to-cart: we OWN the submit. The theme's product form serializes a
    // stale variant id — its variant tracking binds to option <select>s this
    // custom tier UI doesn't use, so the form keeps the default 1-pack id. That
    // posted the wrong variant: one-time multipacks added 1 bottle, and
    // multipack subscriptions paired the 1-pack id with the multipack's selling
    // plan and Shopify 422'd. Syncing the hidden input couldn't win the race, so
    // we POST /cart/add.js directly with the selected tier's id + plan, then fire
    // the theme's documented `apps:product-added-to-cart` hook (quick-cart.js
    // listens on document → refreshes + opens the drawer).
    // The actual POST. Reads the selected tier + mode fresh at call time, so it
    // is correct whether called straight from a click or after the clarity modal.
    function performAdd() {
      var tier = selectedTier();
      if (!tier) return;
      var variantId = tier.getAttribute('data-variant-id');
      if (!variantId) return;
      var planId = (selectedMode() === 'sub') ? (tier.getAttribute('data-selling-plan') || '') : '';
      var body = 'id=' + encodeURIComponent(variantId) + '&quantity=1';
      if (planId) body += '&selling_plan=' + encodeURIComponent(planId);
      atcBtns.forEach(function (b) { b.classList.add('loading'); b.setAttribute('disabled', ''); });
      if (errorEl) { errorEl.style.display = 'none'; errorEl.textContent = ''; }
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: body
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      }).then(function (res) {
        atcBtns.forEach(function (b) { b.classList.remove('loading'); b.removeAttribute('disabled'); });
        if (!res.ok) {
          var msg = (res.data && (res.data.description || res.data.message)) || 'Sorry, this could not be added to your cart.';
          if (errorEl) { errorEl.textContent = msg; errorEl.style.display = ''; }
          return;
        }
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: { item: res.data } }));
        bhbyPublish('bhby_add_to_cart_ok', { variant_id: variantId, bottles: tier.getAttribute('data-bottles') || null, mode: selectedMode(), ab: bhbyAb() });
      }).catch(function () {
        // Network failure: show the same inline error the non-ok branch uses.
        // The old silent redirect to /cart landed shoppers on an empty cart
        // with nothing added and no explanation (CRO audit D7, 2026-10-30).
        atcBtns.forEach(function (b) { b.classList.remove('loading'); b.removeAttribute('disabled'); });
        if (errorEl) {
          errorEl.textContent = 'Sorry, something went wrong adding this to your cart. Please check your connection and try again.';
          errorEl.style.display = '';
        } else {
          window.location.href = '/cart';
        }
      });
    }

    /* ---- Subscription clarity gate ----------------------------------------
       Subscribe & Save is now preselected, so the first time a shopper adds a
       subscription we surface a short modal: they knowingly opt in, or switch to
       one-time. This prevents surprise-recurring chargebacks and is simply honest.
       Shown once per session (sessionStorage); the "How it works" link re-opens it
       in info mode anytime. */
    var clarity = document.querySelector('[data-bhby-clarity]');
    var SEEN_KEY = 'bhby_subclarity_ok';
    function claritySeen() { try { return sessionStorage.getItem(SEEN_KEY) === '1'; } catch (e) { return false; } }
    function markClaritySeen() { try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {} }
    function fillClarity() {
      if (!clarity) return;
      var tier = selectedTier(); if (!tier) return;
      var nameEl = tier.querySelector('.bhby-t-name');
      var pack = nameEl ? nameEl.textContent.trim() : '';
      var subCents = parseInt(tier.getAttribute('data-sub-price'), 10);
      var pct = tier.getAttribute('data-sub-pct') || '';
      var cadence = cadenceFromPlan(tier.getAttribute('data-plan-name') || '');
      var price = !isNaN(subCents) ? money(subCents) : '';
      var d = '';
      if (pack) d += '<strong>' + pack + '</strong>';
      d += cadence ? (', delivered ' + cadence) : ', on a recurring schedule';
      if (price) d += ' at <strong>' + price + '</strong>' + (pct ? ' (' + pct + '% off)' : '');
      d += '. Cancel anytime before your next order.';
      var detailEl = clarity.querySelector('[data-bhby-clarity-detail]');
      if (detailEl) detailEl.innerHTML = d;
    }
    function openClarity(infoMode) {
      if (!clarity) return;
      fillClarity();
      clarity.classList.toggle('bhby-clarity--info', !!infoMode);
      clarity.removeAttribute('hidden');
      document.body.classList.add('bhby-modal-open');
      var primary = clarity.querySelector('[data-bhby-clarity-confirm]');
      // Info mode (opened from "How it works") is a read-only explainer, so the
      // primary just dismisses; the add-to-cart confirm path keeps the CTA label.
      if (primary) { primary.textContent = infoMode ? 'Got it' : 'Subscribe & save'; primary.focus(); }
    }
    function closeClarity() {
      if (!clarity) return;
      clarity.setAttribute('hidden', '');
      document.body.classList.remove('bhby-modal-open');
    }
    if (clarity) {
      clarity.querySelectorAll('[data-bhby-clarity-close]').forEach(function (el) { el.addEventListener('click', closeClarity); });
      var confirmBtn = clarity.querySelector('[data-bhby-clarity-confirm]');
      if (confirmBtn) confirmBtn.addEventListener('click', function () {
        var info = clarity.classList.contains('bhby-clarity--info');
        markClaritySeen(); closeClarity();
        if (!info) performAdd();
      });
      var oneBtn = clarity.querySelector('[data-bhby-clarity-onetime]');
      if (oneBtn) oneBtn.addEventListener('click', function () {
        var info = clarity.classList.contains('bhby-clarity--info');
        setMode('onetime'); sync(); markClaritySeen(); closeClarity();
        if (!info) performAdd();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !clarity.hasAttribute('hidden')) closeClarity();
      });
    }
    document.querySelectorAll('[data-bhby-sub-info]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openClarity(true); });
    });

    // Click handler we OWN (see note above): route subscription adds through the
    // clarity gate once per session, otherwise add straight away.
    function directAdd(e) {
      var tier = selectedTier();
      if (!tier || !tier.getAttribute('data-variant-id')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var isSub = selectedMode() === 'sub' && (tier.getAttribute('data-selling-plan') || '');
      if (isSub && clarity && !claritySeen()) { openClarity(false); return; }
      performAdd();
    }
    atcBtns.forEach(function (b) { b.addEventListener('click', directAdd, true); });

    // Express checkout (Shop Pay / dynamic buttons) can't be intercepted, so keep
    // the form's hidden inputs synced right before the wallet reads them.
    var quickbuy = box.querySelector('.bhby-quickbuy');
    if (quickbuy) quickbuy.addEventListener('click', syncFormInputs, true);
    if (form) form.addEventListener('submit', syncFormInputs, true);
    sync();
  }

  /* ------------------------------------------------------------------ */
  /* Gallery                                                             */
  /* ------------------------------------------------------------------ */
  function initGallery(g) {
    var main = g.querySelector('.bhby-gallery-fg') || g.querySelector('[data-gallery-main] img');
    var bg = g.querySelector('.bhby-gallery-bg');
    var mainBox = g.querySelector('[data-gallery-main]');
    var seal = mainBox ? mainBox.querySelector('.bhby-guarantee-seal') : null;
    var trust = g.querySelector('[data-gallery-trust]'); // desktop-only Made-in-USA badge under the gallery
    var gallery = trust ? trust.closest('.bhby-gallery') : null;
    function syncTrust() {
      if (!trust) return;
      var desktop = window.matchMedia('(min-width:900px)').matches;
      if (desktop) {
        // Stretch the gallery to the hero row height (the grid is align-items:start,
        // so the column is otherwise short) and let the badge fill + center the gap.
        if (gallery) { gallery.style.display = 'flex'; gallery.style.flexDirection = 'column'; gallery.style.gap = '12px'; gallery.style.alignSelf = 'stretch'; }
        trust.style.display = 'flex';
        trust.style.flex = '1 1 auto';
        trust.style.alignItems = 'center';
        trust.style.justifyContent = 'center';
        trust.style.minHeight = '110px';
      } else {
        if (gallery) { gallery.style.display = ''; gallery.style.flexDirection = ''; gallery.style.gap = ''; gallery.style.alignSelf = ''; }
        trust.style.display = 'none';
        trust.style.flex = ''; trust.style.alignItems = ''; trust.style.justifyContent = ''; trust.style.minHeight = '';
      }
    }
    syncTrust();
    window.addEventListener('resize', syncTrust);
    var heroSrc = main ? main.getAttribute('src') : null; // featured image src; the seal only overlays this
    // Blurred-cover backdrop, applied inline so it's cache-proof (independent of stylesheet freshness).
    if (bg) { bg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;transform:scale(1.18);filter:blur(26px) saturate(1.12);z-index:0;pointer-events:none;'; }
    if (main) { main.style.position = 'relative'; main.style.zIndex = '1'; }
    if (seal) { seal.style.transition = 'opacity .18s ease'; }
    function syncSeal(src) {
      // Inline style (cache-proof: doesn't depend on the stylesheet being fresh).
      if (seal && heroSrc) { seal.style.opacity = (src === heroSrc) ? '' : '0'; }
      if (mainBox && heroSrc) { mainBox.classList.toggle('bhby-hide-seal', src !== heroSrc); }
    }
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('bhby-active'); });
        t.classList.add('bhby-active');
        var src = t.getAttribute('data-full');
        var srcset = t.getAttribute('data-full-srcset');
        var alt = t.getAttribute('data-alt') || '';
        if (main && src) { main.src = src; if (srcset) main.srcset = srcset; main.alt = alt; }
        if (bg && src) { bg.src = src; }
        syncSeal(src);
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Sticky ATC                                                          */
  /* ------------------------------------------------------------------ */
  function initSticky() {
    var bar = document.querySelector('.bhby-sticky-atc');
    var anchor = document.querySelector('[data-bhby-sticky-anchor]');
    if (!bar || !anchor) return;
    document.body.classList.add('bhby-has-sticky');

    // Cream background ties the bar to the theme (white read as off); inline = cache-proof.
    bar.style.background = '#FBF5EC';
    bar.style.borderTop = '1px solid #EAD9C5';

    // The stylesheet only shows the sticky bar on mobile (<=899px). Drive desktop
    // visibility + layout inline here so it works regardless of stylesheet freshness.
    var btn = bar.querySelector('.bhby-btn');
    if (btn) btn.style.whiteSpace = 'nowrap';
    function syncStickyViewport() {
      var desktop = window.matchMedia('(min-width:900px)').matches;
      if (desktop) {
        bar.style.display = 'flex';
        bar.style.justifyContent = 'center';
        bar.style.gap = '28px';
        bar.style.paddingLeft = 'max(20px, calc((100vw - 1080px) / 2))';
        bar.style.paddingRight = 'max(20px, calc((100vw - 1080px) / 2))';
        if (btn) { btn.style.flex = '0 0 auto'; btn.style.minWidth = '260px'; btn.style.maxWidth = '360px'; }
        document.body.style.paddingBottom = '76px';
        // Desktop is the centered edge-to-edge bar; clear the mobile float props
        // and restore the top-only border.
        bar.style.left = ''; bar.style.right = ''; bar.style.bottom = '';
        bar.style.borderRadius = ''; bar.style.boxShadow = '';
        bar.style.border = 'none'; bar.style.borderTop = '1px solid #EAD9C5';
      } else {
        // Hand back to the stylesheet's mobile rules for layout...
        bar.style.display = ''; bar.style.justifyContent = ''; bar.style.gap = '';
        bar.style.paddingLeft = ''; bar.style.paddingRight = '';
        if (btn) { btn.style.flex = ''; btn.style.minWidth = ''; btn.style.maxWidth = ''; }
        document.body.style.paddingBottom = '';
        // ...but float it as a contained card so it reads as a deliberate, eye-catching
        // element instead of an edge-to-edge bar (inline = cache-proof on live).
        bar.style.left = '12px'; bar.style.right = '12px';
        bar.style.bottom = 'calc(12px + env(safe-area-inset-bottom))';
        bar.style.borderRadius = '16px';
        bar.style.border = '1px solid #EAD9C5';
        bar.style.boxShadow = '0 10px 30px rgba(38,26,18,.24)';
      }
      document.querySelectorAll('[data-sticky-meta-out]').forEach(applyStickyMeta);
    }
    syncStickyViewport();
    window.addEventListener('resize', syncStickyViewport);

    // Very subtle "breathing" pulse on the sticky CTA. Motion in the periphery is
    // pre-attentively noticed and a gentle, slow pulse on a primary CTA is an
    // established nudge — kept tiny (<=2% scale, ~2.8s) so it reads as alive, not
    // nagging. Honors prefers-reduced-motion (accessibility + avoids annoyance).
    if (btn && btn.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      btn.animate([
        { transform: 'scale(1)',    boxShadow: '0 6px 16px rgba(216,68,123,.22)' },
        { transform: 'scale(1.02)', boxShadow: '0 9px 24px rgba(216,68,123,.42)' },
        { transform: 'scale(1)',    boxShadow: '0 6px 16px rgba(216,68,123,.22)' }
      ], { duration: 2800, iterations: Infinity, easing: 'ease-in-out' });
    }

    // Drive the floating-button stack off the same visibility state: when the
    // sticky bar is showing, lift the back-to-top arrow (and any app-injected
    // accessibility bubble) above it so they don't overlap the CTA on mobile;
    // drop them back to their normal position when the bar hides (hero/buy box
    // in view, or any page without a sticky bar). See bhby-pdp.css .bhby-sticky-visible.
    function setStickyVisible(on) {
      bar.classList.toggle('bhby-show', on);
      document.body.classList.toggle('bhby-sticky-visible', on);
    }
    if (!('IntersectionObserver' in window)) { setStickyVisible(true); return; }
    // Watch the buy box's own Add to cart button, not the whole buy box section.
    // The section is ~2100px tall on mobile and runs ~280px past the button, so
    // observing it left a stretch where the real button had scrolled away and the
    // bar had not arrived yet (measured 2026-09-17 at 375x812). The bar shows
    // whenever that button is off screen, ABOVE or BELOW: on mobile it first sits
    // ~1800px down, so hiding the bar until it scrolled past left the first screen
    // or two with no Add to cart at all. Falls back to the section.
    var target = anchor.querySelector('button[name="add"][data-bhby-atc]') || anchor;
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      setStickyVisible(!e.isIntersecting);
    }, { threshold: 0 }).observe(target);
  }

  /* ------------------------------------------------------------------ */
  /* Write-a-review CTA → trigger Okendo's native review form            */
  /* ------------------------------------------------------------------ */
  function initWriteReview() {
    // Delegated: the Okendo widget hydrates async (app embed), so resolve its
    // button at click-time, not bind-time. If it isn't there yet, the anchor's
    // href (#bhby-reviews) still scrolls the user to the reviews block.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-bhby-write-review]');
      if (!trigger) return;
      var oke = document.querySelector('.okeReviews-reviewsWidget-header-controls-writeReview, [data-oke-reviews-write-review]');
      if (!oke) return; // fall back to the anchor scroll
      e.preventDefault();
      oke.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { oke.click(); }, 350);
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    document.querySelectorAll('[data-bhby-buybox]').forEach(initBuybox);
    document.querySelectorAll('[data-bhby-gallery]').forEach(initGallery);
    initSticky();
    initWriteReview();
  });
})();
